/* eslint-disable angular/window-service */
/* eslint-disable angular/document-service */
/* eslint-disable no-console */
/* eslint-disable angular/log */
require('./app/styles.less');

const bootstrap = require('./bootstrap');
const angular = require('angular');

const runtime = angular.module('msi.runtime', [
  require('@ordergroove/brandy/src/app/frequency')
]);

function loadCss() {
  const cssId = 'msiCss'; // you could encode the css path itself to generate id..

  if (!document.getElementById(cssId)) {
    const head = document.getElementsByTagName('head')[0];
    const link = document.createElement('link');
    link.id = cssId;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    // eslint-disable-next-line no-undef
    link.href = `${__webpack_require__.p}msi.css`;
    link.media = 'all';
    head.appendChild(link);
  }
}

/**
 * Setups the application configuration
 * @example
 * og.msi.configure({
 *     merchantId: '0e5de2bedc5e11e3a2e4bc764e106cf4',
 *     env: 'staging',
 *     authMode: 'ajax',
 *     authUrl: '/msi/auth.json',
 *     config: { landingPageUrl: '/msi' },
 *     apiUrls: { masterDbUrl: 'https://staging.v2.ordergroove.com' },
 *     publicPath: '/'
 *     externalPayment: {
 *        visible: true,
 *        url: '',
 *        hostedByOg: true,
 *     },
 *     locales: {
 *        en_US: {
 *          "SHIPMENTS_UNSENT_HEADER": "Awesome Upcoming Shipments",
 *        }
 *     },
 *     analyticsId: 'some-gaid',
 *     styles: [["--og-regular-text-size","456px"], ...],
 *     elementsToConfigs: [
 *        variationName: [variation-of-the-application-configuration]
 *    ]
 * });
 * @param {Object} config
 */
function configure(publishedConfig, elementsToConfigs) {
  const variationName = window.localStorage.getItem('ogMSIVariation');
  if (angular.isUndefined(elementsToConfigs)) {
    configureHelper(publishedConfig);
  }
  else {
    const runtimeConfig = elementsToConfigs[variationName] || publishedConfig;
    const { styles, ...config } = runtimeConfig;
    configureHelper(config);
    injectCss(styles);
  }
  return module.exports;
}

function configureHelper(config) {
  const constantsSupported = /^(merchantId|env|authMode|authUrl|config|apiUrls|externalPayment|externalShipping|quantityControlConfig|publicPath|countriesConfig)$/;

  runtime.constant('sspcConfig', config);

  Object.entries(config).forEach(([key, value]) => {
    if (constantsSupported.test(key)) {
      runtime.constant(key, value);
      if (key === 'publicPath') {
        // eslint-disable-next-line no-undef, camelcase
        __webpack_require__.p = value;
      }
    }
    else if (key === 'settings' && value.frequencies) {
      runtime.config(['frequenciesProvider', (frequenciesProvider) => {
        frequenciesProvider.override(value.frequencies);
      }]);
    }
    else if (key === 'locales') {
      const app = angular.module('msi.localizations', ['pascalprecht.translate', 'ngSanitize', require('./app/utils')]);
      app.config([
        '$translateProvider',
        prv =>
          Object.entries(value).forEach(([name, translations]) =>
            prv.translations(name, {
              ...require('./locale/en_US.json'),
              ...translations
            }))
      ]);

      app.config(require('./app/locale/locale.config'));

      app.constant('localeFormat', require('./app/locale/locale.format'));
      app.filter('ogProductLocale', require('./app/locale/product-locale-filter'));
    }
    else {
      console.warn(`MSI Unsupported configuration ${key}`);
    }
  });

  loadCss();
}

function setStyleProperties(styles) {
  styles.forEach(([key, value]) => document.body.style.setProperty(key, value));
}

function injectCss(styles) {
  if (document.readyState === 'loading') {
    angular.element(document).ready(() => {
      setStyleProperties(styles);
    });
  }
  else {
    setStyleProperties(styles);
  }
}

angular.element(document).ready(() => {
  const load = () => bootstrap(require('./app'), ['msi.localizations', runtime.name]);
  try {
    // Check if there is msi.localizations defined by static-oring-server or runtime
    angular.module('msi.localizations');
    load();
  }
  catch (err) {
    // If there are no locales load from disk
    import(/* webpackChunkName: "msi/locale" */ './app/locale').then(load);
  }
});
// Notice the require('./app') occurs here so msi.runtine variables
// can take precedence over

module.exports = (...args) => configure(...args);
module.exports.configure = configure;
module.exports.loadCss = loadCss;
module.exports.angular = angular;
